import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.div`
  align-self: center;
  height: 50%;
  border-left: 1px solid ${props => props.theme.colors.boxBorderLighter};
`;

const PcBox = styled(DefaultBox)`
  margin-left: 1rem;
  padding-left: 1rem;
`;

const MobileBox = styled(DefaultBox)`
  margin-left: 0.5rem;
  padding-left: 0.5rem;
`;

export const NavbarSeparatorDefaultBox = styledByDevice(PcBox, MobileBox);
